var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('audio',{ref:"notifyAudio",attrs:{"preload":"auto"}},[_c('source',{attrs:{"src":"/static/notify.mp3","type":"audio/mpeg"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }